export enum SingleWaveDropVoteSize {
  NORMAL = "NORMAL",
  COMPACT = "COMPACT",
  MINI = "MINI",
}

export enum SingleWaveDropVoteSubmissionMode {
  WAIT_FOR_CONFIRMATION = "WAIT_FOR_CONFIRMATION",
  BACKGROUND_AFTER_AUTH = "BACKGROUND_AFTER_AUTH",
}
